const productActionType = {
  // pre order products
  FETCH_PRE_ORDERED_PRODUCTS: "FETCH_PRE_ORDERED_PRODUCTS",
  FETCH_PRE_ORDERED_PRODUCTS_SUCCESS: "FETCH_PRE_ORDERED_PRODUCTS_SUCCESS",
  FETCH_PRE_ORDERED_PRODUCTS_FAILURE: "FETCH_PRE_ORDERED_PRODUCTS_FAILURE",
  // products
  FETCH_PRODUCTS: "FETCH_PRODUCTS",
  FETCH_PRODUCTS_SUCCESS: "FETCH_PRODUCTS_SUCCESS",
  FETCH_PRODUCTS_FAILURE: "FETCH_PRODUCTS_FAILURE",
  // collections
  FETCH_COLLECTIONS: "FETCH_COLLECTIONS",
  FETCH_COLLECTIONS_SUCCESS: "FETCH_COLLECTIONS_SUCCESS",
  FETCH_COLLECTIONS_FAILURE: "FETCH_COLLECTIONS_FAILURE",
  // find product
  FIND_PRODUCT: "FIND_PRODUCT",
  FIND_PRODUCT_SUCCESS: "FIND_PRODUCT_SUCCESS",
  FIND_PRODUCT_FAILURE: "FIND_PRODUCT_FAILURE",
  // find collection
  FIND_COLLECTION: "FIND_COLLECTION",
  FIND_COLLECTION_SUCCESS: "FIND_COLLECTION_SUCCESS",
  FIND_COLLECTION_FAILURE: "FIND_COLLECTION_FAILURE",
  // pre-order ids
  SAVE_PRE_ORDER_IDS: "SAVE_PRE_ORDER_IDS",
  // process pre-order
  PROCESS_PRE_ORDERED_PRODUCTS: "PROCESS_PRE_ORDERED_PRODUCTS",
  PROCESS_PRE_ORDERED_PRODUCTS_UPDATE: "PROCESS_PRE_ORDERED_PRODUCTS_UPDATE",
  PROCESS_PRE_ORDERED_PRODUCTS_SUCCESS: "PROCESS_PRE_ORDERED_PRODUCTS_SUCCESS",
  PROCESS_PRE_ORDERED_PRODUCTS_FAILURE: "PROCESS_PRE_ORDERED_PRODUCTS_FAILURE",
  // search
  CLEAR_SEARCH: "CLEAR_SEARCH",
  // save selected product ids to store
  SAVE_PRODUCT_IDS: "SAVE_PRODUCT_IDS",
  // save product filters to store
  SAVE_PRODUCT_FILTERS: "SAVE_PRODUCT_FILTERS",
  // save additional products to store
  FETCH_ADDITIONAL_TIMESACT_PRODUCTS: "FETCH_ADDITIONAL_TIMESACT_PRODUCTS",
  FETCH_ADDITIONAL_TIMESACT_PRODUCTS_SUCCESS: "FETCH_ADDITIONAL_TIMESACT_PRODUCTS_SUCCESS",
  FETCH_ADDITIONAL_TIMESACT_PRODUCTS_FAILURE: "FETCH_ADDITIONAL_TIMESACT_PRODUCTS_FAILURE",
  // remove/update - products/variants in filtered products
  REMOVE_VARIANTS_IN_FILTERED_PRODUCTS: "REMOVE_VARIANTS_IN_FILTERED_PRODUCTS",
  REMOVE_ALL_FILTERED_PRODUCTS: "REMOVE_ALL_FILTERED_PRODUCTS",
  UPDATE_FILTERED_PRODUCTS: "UPDATE_FILTERED_PRODUCTS",
};

export default productActionType;
